import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import _inherits from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { FileAudioSource, MicAudioSource, PcmRecorder } from "../../common.browser/Exports";
import { Contracts } from "../Contracts";
import { AudioInputStream, PullAudioInputStreamCallback, PullAudioOutputStream, PushAudioOutputStream, PushAudioOutputStreamCallback, SpeakerAudioDestination } from "../Exports";
import { AudioFileWriter } from "./AudioFileWriter";
import { PullAudioInputStreamImpl } from "./AudioInputStream";
import { PushAudioOutputStreamImpl } from "./AudioOutputStream";
/**
 * Represents audio input configuration used for specifying what type of input to use (microphone, file, stream).
 * @class AudioConfig
 * Updated in version 1.11.0
 */

export var AudioConfig = /*#__PURE__*/function () {
  function AudioConfig() {
    _classCallCheck(this, AudioConfig);
  }

  _createClass(AudioConfig, null, [{
    key: "fromDefaultMicrophoneInput",

    /**
     * Creates an AudioConfig object representing the default microphone on the system.
     * @member AudioConfig.fromDefaultMicrophoneInput
     * @function
     * @public
     * @returns {AudioConfig} The audio input configuration being created.
     */
    value: function fromDefaultMicrophoneInput() {
      var pcmRecorder = new PcmRecorder();
      return new AudioConfigImpl(new MicAudioSource(pcmRecorder));
    }
    /**
     * Creates an AudioConfig object representing a microphone with the specified device ID.
     * @member AudioConfig.fromMicrophoneInput
     * @function
     * @public
     * @param {string | undefined} deviceId - Specifies the device ID of the microphone to be used.
     *        Default microphone is used the value is omitted.
     * @returns {AudioConfig} The audio input configuration being created.
     */

  }, {
    key: "fromMicrophoneInput",
    value: function fromMicrophoneInput(deviceId) {
      var pcmRecorder = new PcmRecorder();
      return new AudioConfigImpl(new MicAudioSource(pcmRecorder, deviceId));
    }
    /**
     * Creates an AudioConfig object representing the specified file.
     * @member AudioConfig.fromWavFileInput
     * @function
     * @public
     * @param {File} fileName - Specifies the audio input file. Currently, only WAV / PCM with 16-bit
     *        samples, 16 kHz sample rate, and a single channel (Mono) is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */

  }, {
    key: "fromWavFileInput",
    value: function fromWavFileInput(file) {
      return new AudioConfigImpl(new FileAudioSource(file));
    }
    /**
     * Creates an AudioConfig object representing the specified stream.
     * @member AudioConfig.fromStreamInput
     * @function
     * @public
     * @param {AudioInputStream | PullAudioInputStreamCallback} audioStream - Specifies the custom audio input
     *        stream. Currently, only WAV / PCM with 16-bit samples, 16 kHz sample rate, and a single channel
     *        (Mono) is supported.
     * @returns {AudioConfig} The audio input configuration being created.
     */

  }, {
    key: "fromStreamInput",
    value: function fromStreamInput(audioStream) {
      if (audioStream instanceof PullAudioInputStreamCallback) {
        return new AudioConfigImpl(new PullAudioInputStreamImpl(audioStream));
      }

      if (audioStream instanceof AudioInputStream) {
        return new AudioConfigImpl(audioStream);
      }

      throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing the default speaker.
     * @member AudioConfig.fromDefaultSpeakerOutput
     * @function
     * @public
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */

  }, {
    key: "fromDefaultSpeakerOutput",
    value: function fromDefaultSpeakerOutput() {
      return new AudioOutputConfigImpl(new SpeakerAudioDestination());
    }
    /**
     * Creates an AudioConfig object representing the custom IPlayer object.
     * You can use the IPlayer object to control pause, resume, etc.
     * @member AudioConfig.fromSpeakerOutput
     * @function
     * @public
     * @param {IPlayer} player - the IPlayer object for playback.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.12.0
     */

  }, {
    key: "fromSpeakerOutput",
    value: function fromSpeakerOutput(player) {
      if (player === undefined) {
        return AudioConfig.fromDefaultSpeakerOutput();
      }

      if (player instanceof SpeakerAudioDestination) {
        return new AudioOutputConfigImpl(player);
      }

      throw new Error("Not Supported Type");
    }
    /**
     * Creates an AudioConfig object representing a specified output audio file
     * @member AudioConfig.fromAudioFileOutput
     * @function
     * @public
     * @param {PathLike} filename - the filename of the output audio file
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */

  }, {
    key: "fromAudioFileOutput",
    value: function fromAudioFileOutput(filename) {
      return new AudioOutputConfigImpl(new AudioFileWriter(filename));
    }
    /**
     * Creates an AudioConfig object representing a specified audio output stream
     * @member AudioConfig.fromStreamOutput
     * @function
     * @public
     * @param {AudioOutputStream | PushAudioOutputStreamCallback} audioStream - Specifies the custom audio output
     *        stream.
     * @returns {AudioConfig} The audio output configuration being created.
     * Added in version 1.11.0
     */

  }, {
    key: "fromStreamOutput",
    value: function fromStreamOutput(audioStream) {
      if (audioStream instanceof PushAudioOutputStreamCallback) {
        return new AudioOutputConfigImpl(new PushAudioOutputStreamImpl(audioStream));
      }

      if (audioStream instanceof PushAudioOutputStream) {
        return new AudioOutputConfigImpl(audioStream);
      }

      if (audioStream instanceof PullAudioOutputStream) {
        return new AudioOutputConfigImpl(audioStream);
      }

      throw new Error("Not Supported Type");
    }
  }]);

  return AudioConfig;
}();
/**
 * Represents audio input stream used for custom audio input configurations.
 * @private
 * @class AudioConfigImpl
 */
// tslint:disable-next-line:max-classes-per-file

export var AudioConfigImpl = /*#__PURE__*/function (_AudioConfig) {
  _inherits(AudioConfigImpl, _AudioConfig);

  var _super = _createSuper(AudioConfigImpl);

  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {IAudioSource} source - An audio source.
   */
  function AudioConfigImpl(source) {
    var _this;

    _classCallCheck(this, AudioConfigImpl);

    _this = _super.call(this);
    _this.privSource = source;
    return _this;
  }
  /**
   * Format information for the audio
   */


  _createClass(AudioConfigImpl, [{
    key: "close",

    /**
     * @member AudioConfigImpl.prototype.close
     * @function
     * @public
     */
    value: function close() {
      this.privSource.turnOff();
    }
    /**
     * @member AudioConfigImpl.prototype.id
     * @function
     * @public
     */

  }, {
    key: "id",
    value: function id() {
      return this.privSource.id();
    }
    /**
     * @member AudioConfigImpl.prototype.turnOn
     * @function
     * @public
     * @returns {Promise<boolean>} A promise.
     */

  }, {
    key: "turnOn",
    value: function turnOn() {
      return this.privSource.turnOn();
    }
    /**
     * @member AudioConfigImpl.prototype.attach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     * @returns {Promise<IAudioStreamNode>} A promise.
     */

  }, {
    key: "attach",
    value: function attach(audioNodeId) {
      return this.privSource.attach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.detach
     * @function
     * @public
     * @param {string} audioNodeId - The audio node id.
     */

  }, {
    key: "detach",
    value: function detach(audioNodeId) {
      return this.privSource.detach(audioNodeId);
    }
    /**
     * @member AudioConfigImpl.prototype.turnOff
     * @function
     * @public
     * @returns {Promise<boolean>} A promise.
     */

  }, {
    key: "turnOff",
    value: function turnOff() {
      return this.privSource.turnOff();
    }
    /**
     * @member AudioConfigImpl.prototype.events
     * @function
     * @public
     * @returns {EventSource<AudioSourceEvent>} An event source for audio events.
     */

  }, {
    key: "setProperty",
    value: function setProperty(name, value) {
      Contracts.throwIfNull(value, "value");

      if (undefined !== this.privSource.setProperty) {
        this.privSource.setProperty(name, value);
      } else {
        throw new Error("This AudioConfig instance does not support setting properties.");
      }
    }
  }, {
    key: "getProperty",
    value: function getProperty(name, def) {
      if (undefined !== this.privSource.getProperty) {
        return this.privSource.getProperty(name, def);
      } else {
        throw new Error("This AudioConfig instance does not support getting properties.");
      }

      return def;
    }
  }, {
    key: "format",
    get: function get() {
      return this.privSource.format;
    }
  }, {
    key: "events",
    get: function get() {
      return this.privSource.events;
    }
  }, {
    key: "deviceInfo",
    get: function get() {
      return this.privSource.deviceInfo;
    }
  }]);

  return AudioConfigImpl;
}(AudioConfig); // tslint:disable-next-line:max-classes-per-file

export var AudioOutputConfigImpl = /*#__PURE__*/function (_AudioConfig2) {
  _inherits(AudioOutputConfigImpl, _AudioConfig2);

  var _super2 = _createSuper(AudioOutputConfigImpl);

  /**
   * Creates and initializes an instance of this class.
   * @constructor
   * @param {IAudioDestination} destination - An audio destination.
   */
  function AudioOutputConfigImpl(destination) {
    var _this2;

    _classCallCheck(this, AudioOutputConfigImpl);

    _this2 = _super2.call(this);
    _this2.privDestination = destination;
    return _this2;
  }

  _createClass(AudioOutputConfigImpl, [{
    key: "write",
    value: function write(buffer) {
      this.privDestination.write(buffer);
    }
  }, {
    key: "close",
    value: function close() {
      this.privDestination.close();
    }
  }, {
    key: "id",
    value: function id() {
      return this.privDestination.id();
    }
  }, {
    key: "setProperty",
    value: function setProperty(name, value) {
      throw new Error("This AudioConfig instance does not support setting properties.");
    }
  }, {
    key: "getProperty",
    value: function getProperty(name, def) {
      throw new Error("This AudioConfig instance does not support getting properties.");
    }
  }, {
    key: "format",
    set: function set(format) {
      this.privDestination.format = format;
    }
  }]);

  return AudioOutputConfigImpl;
}(AudioConfig);